import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectChatsState } from "../store/chats/selectors";
import { fetchDocsByConversationId } from "../store/chats/thunks";

export const useDocuments = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, selectedChatId } = useSelector(selectChatsState);

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[selectedChatId];
  }, [selectedChatId, selectedTenantId, chatsByTenants]);

  const fetchDocs = useCallback(() => {
    if (
      selectedChatId &&
      !selectedChat?.docsLoading &&
      (selectedChat?.hasMore ?? true)
    ) {
      dispatch(
        fetchDocsByConversationId({
          conversation_id: selectedChat?.id,
          tenant_id: selectedTenantId,
          page: selectedChat?.docsPage || 1,
        }),
      );
    }
  }, [selectedTenantId, selectedChatId, selectedChat, dispatch]);

  return {
    loading: selectedChat?.docsLoading,
    docs: selectedChat?.docs || [],
    hasMore: selectedChat?.hasMore ?? true,
    fetchDocs,
    selectedTenantId,
    selectedChatId
  };
};
